import styled from "styled-components";

export const Span = styled.span`
  display: inline-block;
  opacity: ${(props) => props.opacity};
  transition: opacity 1.5s;
`;
